






















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Modal extends Vue {
  @Prop({
    type: String,
    default: 'TEXT TITLE'
  }) title!: string

  @Prop(Boolean) outsideClick!: boolean
  @Prop({
    type: Boolean,
    default: true
  }) closeIcon!: boolean

  private close (): void {
    if (this.outsideClick)
      this.$emit('close')
  }
}
